import { useState } from 'react';

import { requestPasswordReset } from '../../api/auth';

/**
 * Password reset request. The backend replies the same way whether or not
 * the email has an account, so the success message stays neutral too.
 */
export default function ResetView({ onSwitch }) {
  const [email, setEmail] = useState('');
  const [info, setInfo] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setSubmitting(true);
    try {
      await requestPasswordReset({ email });
      setInfo('If an account exists for that email, we’ve sent a link to reset your password. Check your inbox and spam folder.');
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="auth-panel" onSubmit={handleSubmit} noValidate>
      <h2 className="auth-title">Reset password</h2>
      <p className="auth-sub">We&apos;ll send you a link to reset your password</p>

      {error && <div className="auth-error">{error}</div>}
      {info && <div className="auth-success">{info}</div>}

      <div className="field">
        <label htmlFor="reset-email">Email</label>
        <input
          type="email"
          id="reset-email"
          placeholder="you@example.com"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <button className="auth-submit" type="submit" disabled={submitting}>
        {submitting ? 'Sending…' : 'Send Reset Link'}
      </button>

      <p className="auth-switch">
        <a href="#login" onClick={(e) => { e.preventDefault(); onSwitch('login'); }}>
          Back to log in
        </a>
      </p>
    </form>
  );
}
